// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hD","cusMtdicon":"hD"};